module.exports = __webpack_public_path__ + "img/Iraq.d47a77ae.svg";